import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { TituloReceberPagamentoComponent } from './titulo-receber-pagamento.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        TituloReceberPagamentoComponent
    ],
    exports: [
        TituloReceberPagamentoComponent
    ]
})
export class TituloReceberPagamentoModule { }
